import {create} from 'zustand'
import {subscribeWithSelector} from 'zustand/middleware'
import {v4 as uuid} from 'uuid'
import { indexOf, isUndefined, isNull, isEmpty } from 'lodash'
import {store} from '../../../../MainApp'
import {history} from 'store'
import {addSectionToTemplate, moveSectionTemplate, removeSectionTemplate, updateSectionMailTemplate, moveContentNewSectionTemplate, 
  moveContentTemplate, addContentTemplate, addColumnTemplate, removeContentTemplate, removeColumnTemplate, updateColumnWidthsTemplate,
  updateContentTemplate, updateMailTemplateByMeta, 
  moveSocialMailTemplate, removeSocialMailTemplate, updateSocialMailTemplate, addSocialMailTemplate
} from 'actions'

let dummyMail = {
  headerYPadding:50,
  bodyYPadding:50,
  footerYPadding:50,

  headerBgColor: '#F7F7F7',
  bodyBgColor: '#FFFFFF',
  footerBgColor: '#333333',

  headersections: [
  ],
  bodysections: [
    // {id:uuid(),parent: 'body', columns:[{ id:uuid(), text: ''}]}
  ],
  footersections: [
  ]
}

const defaultContentParams = (contentType) => ({
  text: '', 
  pt:10,pr:12,pb:10,pl:12,
  height: 50,
  imgUrl: null,
  dividerColor: '#000',
  dividerHeight: 5,
  dividerRadius: 0,
  imgSize: 100,
  align: 'center',
  justify: 'center',
  btnWidth: 130,
  btnHeight: 40,
  btnText: 'Knapp',
  btnLink: '',
  btnFontSize: 24,
  btnRadius: 35,
  btnBgColor: '#2DBAB5',
  btnColor: 'white',
  iconColor: '#15B59D',
  videoLink: '',
  socials: contentType === 'social' ? [
    {id: uuid(), value: 1, link: 'facebook.com/'},
    {id: uuid(), value: 2, link: 'instagram.com/'},
    {id: uuid(), value: 3, link: 'twitter.com/'}
  ] : []
})

const getDispatchData = () => {
  const Userid = store.getState().auth.authUser.user_id
  const Afid = store.getState().accountsData.currentAccount.id
  return {Userid, Afid}
}


const maxSectionWidth = 596

const useStore = create(subscribeWithSelector((set,get) => ({
  
  setCurrentMailTemplate: (currentMailTemplate) => set(() => { 
    return {
      currentMailTemplate: isNull(currentMailTemplate) ? dummyMail : currentMailTemplate,
      headersections: isNull(currentMailTemplate) ? dummyMail.headersections : currentMailTemplate.headersections,
      bodysections: isNull(currentMailTemplate) ? dummyMail.bodysections : currentMailTemplate.bodysections,
      footersections: isNull(currentMailTemplate) ? dummyMail.footersections : currentMailTemplate.footersections,
    }
  }), 

  currentMailTemplate: dummyMail,
  headersections: dummyMail.headersections,
  bodysections: dummyMail.bodysections,
  footersections: dummyMail.footersections,

  setYPadding: (parent, value) => (set(() => {

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      const {Userid, Afid} = getDispatchData()
      store.dispatch(updateMailTemplateByMeta(Userid, Afid, `${parent}YPadding`, value, Tempid, Campid))
    }

    return{
      currentMailTemplate:{
        ...get().currentMailTemplate, 
        [`${parent}YPadding`]: value
      }
    }
  })),
  setBgColor: (parent, value) => (set(() => {

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      const {Userid, Afid} = getDispatchData()
      store.dispatch(updateMailTemplateByMeta(Userid, Afid, `${parent}BgColor`, value, Tempid, Campid))
    }

    return{
      currentMailTemplate:{
        ...get().currentMailTemplate, 
        [`${parent}BgColor`]: value
      }
    }
  })),
  uploadImageOpen: false,
  targetContentData: {},
  setUploadImageOpen: (open, targetContentData) => set(() => ({uploadImageOpen:open, targetContentData:targetContentData})),

  hoverContentContainer: null,
  setHoverContentContainer: (parent) =>  set(() => {
    return {
      hoverContentContainer: get().isDragging ? get().hoverContentContainer : parent
    }
  }),
  selectedSection: null,
  selectedContent: null,
  selectedColumn: null,

  setSelectedContent: (parent, sectionId, columnId, content) => set(() => {

    let section = [...get()[`${parent}sections`]].find(s => s.id === sectionId)
    section = {...section, 
      columns: section.columns.map(c => c.id === columnId? {...c, content: c.content.map(ct => ct.id === content.id ? {...ct, selected: true}:{...ct, selected: false})} : {...c, content: c.content.map(ct => ({...ct, selected: false}))})}
    let column = section.columns.find(c => c.id === columnId)

    let headercontentallIsDeselected = get().headersections.every((s) => !s.selected && s.columns.every(c => c.content.every(ct => !ct.selected)))
    let bodycontentallIsDeselected = get().bodysections.every((s) => !s.selected && s.columns.every(c => c.content.every(ct => !ct.selected)))
    let footercontentallIsDeselected = get().footersections.every((s) => !s.selected && s.columns.every(c => c.content.every(ct => !ct.selected)))
    
    return {
      selectedContent: content,
      selectedSection: section,
      selectedColumn: column,
      headersections: headercontentallIsDeselected && section.parent !== 'header' ? 
        get().headersections : 
        [...get().headersections.map(s => s.id === section.id ?
          {...s, selected: false, columns: s.columns.map(c => c.id === columnId ?
            {...c, content: c.content.map(ct => ct.id === content.id ?
              {...ct, selected: true}:
              {...ct, selected: false}
              )}:
            {...c, content: c.content.map(ct => ({...ct, selected: false}))}
          )} :
          {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
        )],
      bodysections: bodycontentallIsDeselected && section.parent !== 'body' ? 
      get().bodysections :
      [...get().bodysections.map(s => s.id === section.id ?
        {...s, selected: false, columns: s.columns.map(c => c.id === columnId ?
          {...c, content: c.content.map(ct => ct.id === content.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, selected: false,columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
      footersections: footercontentallIsDeselected && section.parent !== 'footer' ? 
      get().footersections : 
      [...get().footersections.map(s => s.id === section.id ?
        {...s, selected: false, columns: s.columns.map(c => c.id === columnId ?
          {...c, content: c.content.map(ct => ct.id === content.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, selected: false,columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
    }
  }),
  setSelectedSection: (parent, sectionId, ) => set(() => {

    let section = [...get()[`${parent}sections`]].find(s => s.id === sectionId)
    section = {...section, selected: true}

    let headercontentallIsDeselected = get().headersections.every((s) => !s.selected && s.columns.every(c => c.content.every(ct => !ct.selected)))
    let bodycontentallIsDeselected = get().bodysections.every((s) => !s.selected && s.columns.every(c => c.content.every(ct => !ct.selected)))
    let footercontentallIsDeselected = get().footersections.every((s) => !s.selected && s.columns.every(c => c.content.every(ct => !ct.selected)))
    
    return {
      selectedContent: null,
      selectedSection: section,
      selectedColumn: null,
      headersections: headercontentallIsDeselected && section.parent !== 'header' ? 
        get().headersections : 
        [...get().headersections.map(s => s.id === section.id ?
          {...s, selected: true, columns: s.columns.map(c => 
            ({...c, selected: false, content: c.content.map(ct => 
              ({...ct, selected: false})
              )})
          )} :
          {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
        )],
      bodysections: bodycontentallIsDeselected && section.parent !== 'body' ? 
      get().bodysections :
      [...get().bodysections.map(s => s.id === section.id ?
        {...s, selected: true, columns: s.columns.map(c => 
          ({...c, selected: false, content: c.content.map(ct => 
            ({...ct, selected: false})
            )})
        )} :
        {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
      footersections: footercontentallIsDeselected && section.parent !== 'footer' ? 
      get().footersections : 
      [...get().footersections.map(s => s.id === section.id ?
        {...s, selected: true, columns: s.columns.map(c => 
          ({...c, selected: false, content: c.content.map(ct => 
            ({...ct, selected: false})
            )})
        )} :
        {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
    }
  }),
  deSelectContent: (parent) => set(() => {


    let headercontentallIsDeselected = get().headersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let bodycontentallIsDeselected = get().bodysections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let footercontentallIsDeselected = get().footersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    
    return {
      selectedContent: null,
      selectedSection: null,
      selectedColumn: null,
      headersections: headercontentallIsDeselected && parent!== 'header' ? 
        get().headersections : 
        [...get().headersections.map(s =>(
          {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))})
        )],
      bodysections: bodycontentallIsDeselected && parent !== 'body' ? 
      get().bodysections : 
      [...get().bodysections.map(s =>(
        {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))})
      )],
      footersections: footercontentallIsDeselected && parent !== 'footer' ? 
      get().footersections : 
        [...get().footersections.map(s =>(
          {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))})
        )],
    }
  }),

  isDragging: false,
  setIsDragging: (input) => set(() => ({isDragging:input})),
  isDraggingBlock: false,
  setIsDraggingBlock: (input) => set(() => ({isDraggingBlock:input})),
  // setSelectedSection: (section) => set(() => {
  //   let headersectionsallIsDeselected = get().headersections.every((s) => !s.selected)
  //   let bodysectionsallIsDeselected = get().bodysections.every((s) => !s.selected)
  //   let footersectionsallIsDeselected = get().footersections.every((s) => !s.selected)
    
  //   return {
  //     selectedSection: isNull(get().selectedSection) ? section : (get().selectedSection.id === section.id ? null : section),
  //     headersections: headersectionsallIsDeselected && section.parent !== 'header' ? get().headersections : [...get().headersections.map(s => s.id === section.id ? {...s, selected: !s.selected}:{...s, selected:false})],
  //     bodysections: bodysectionsallIsDeselected && section.parent !== 'body' ? get().bodysections : [...get().bodysections.map(s => s.id === section.id ? {...s, selected: !s.selected}:{...s, selected:false})],
  //     footersections: footersectionsallIsDeselected && section.parent !== 'footer' ? get().footersections : [...get().footersections.map(s => s.id === section.id ? {...s, selected: !s.selected}:{...s, selected:false})],
  //   }
  // }),

  addColumn: (parent, sectionId, index, contentType) => set(() => {

    let headercontentallIsDeselected = get().headersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let bodycontentallIsDeselected = get().bodysections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let footercontentallIsDeselected = get().footersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
   
    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    let newContentItem = {
      id:uuid(), 
      contentType,
      ...defaultContentParams(contentType),
      selected: true
    }

    let columns = [...thisSection.columns]
    let newColumn = { 
      id:uuid(), 
      width: maxSectionWidth / (columns.length+1),
      content: [newContentItem]
    }
    columns.splice(index,0,newColumn)

    columns = [...columns.map(c => ({...c, width: maxSectionWidth / columns.length}))]

    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      const {Userid, Afid} = getDispatchData()
      store.dispatch(addColumnTemplate(Userid, Afid, newColumn, columns, sectionId, Tempid, Campid))
    }

    return {
      selectedSection: thisSection,
      selectedContent: newContentItem,
      selectedColumn: newColumn,

      headersections: headercontentallIsDeselected && parent !== 'header' ? 
        get().headersections : 
        [...(parent === 'header' ? parentSections : get().headersections).map(s => s.id === thisSection.id ?
          {...s, columns: s.columns.map(c => c.id === newColumn.id ?
            {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
              {...ct, selected: true}:
              {...ct, selected: false}
              )}:
            {...c, content: c.content.map(ct => ({...ct, selected: false}))}
          )} :
          {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
        )],
      bodysections: bodycontentallIsDeselected && parent !== 'body' ? 
      get().bodysections :
      [...(parent === 'body' ? parentSections : get().headersections).map(s => s.id === thisSection.id ?
        {...s, columns: s.columns.map(c => c.id === newColumn.id ?
          {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
      footersections: footercontentallIsDeselected && parent !== 'footer' ? 
      get().footersections : 
      [...(parent === 'footer' ? parentSections : get().headersections).map(s => s.id === thisSection.id ?
        {...s, columns: s.columns.map(c => c.id === newColumn.id ?
          {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
    }
  }),
  removeColumn: (parent, sectionId, index) => set(() => {

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
   
    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    let columns = [...thisSection.columns]

    let thisColumn = {...columns[index]}

    columns.splice(index,1)
    columns = [...columns.map(c => ({...c, width: maxSectionWidth / columns.length}))]
    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)
    
    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      const {Userid, Afid} = getDispatchData()
      store.dispatch(removeColumnTemplate(Userid, Afid, thisColumn, columns, Tempid, Campid))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? thisSection : get().selectedSection)
    }
  }),
  removeContentItem: (parent, sectionId, index, contentId) => set(() => {

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
   
    let thisSectionIndex = indexOf(parentSections, thisSection)

    let shouldRemoveOriginSection = thisSection.columns.length === 1 && isEmpty(thisSection.columns.filter(c => c.content > 1))

    parentSections.splice(thisSectionIndex,1)

    let columns = [...thisSection.columns]

    let thisColumn = columns[index]

    thisColumn = {...thisColumn, content: thisColumn.content.filter(ct => ct.id !== contentId)}

    columns.splice(index,1)
    columns.splice(index, 0, thisColumn)

    // columns = [...columns.map(c => ({...c, width: maxSectionWidth / columns.length}))]
    thisSection = {...thisSection, columns}

    if(!shouldRemoveOriginSection) parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      const ContentOrder = thisColumn.content.map(c => c.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(removeContentTemplate(Userid, Afid, {id:contentId}, ContentOrder, Tempid, Campid, shouldRemoveOriginSection ? sectionId : null ))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? (shouldRemoveOriginSection ? null : thisSection) : get().selectedSection),
      selectedContent: isNull(get().selectedContent) ? get().selectedContent : (get().selectedContent.id === contentId ? null : get().selectedContent)
    }
  }),
  addContentItem: (parent, sectionId, columnIndex, contentIndex, contentType, content) => set(() => {

    console.log('addContentItem')
    
    let headercontentallIsDeselected = get().headersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let bodycontentallIsDeselected = get().bodysections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let footercontentallIsDeselected = get().footersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
   
    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    let columns = [...thisSection.columns]

    let thisColumn = columns[columnIndex]
    let newContents = [...thisColumn.content]

    let newContentItem = {
      id:uuid(), 
      contentType,
      ...defaultContentParams(contentType),
      selected: true,
    }

    newContents.splice(contentIndex, 0, newContentItem)
    
    thisColumn = {...thisColumn, content: newContents}

    // thisColumn = {...thisColumn, content: thisColumn.content.filter(ct => ct.id !== contentId)}

    columns.splice(columnIndex,1)
    columns.splice(columnIndex, 0, thisColumn)

    // columns = [...columns.map(c => ({...c, width: maxSectionWidth / columns.length}))]
    thisSection = {...thisSection, columns, selected: true}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      let ContentOrder = newContents.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(addContentTemplate(Userid, Afid, newContentItem, ContentOrder, thisColumn.id, Tempid, Campid))
    }

    return {
      selectedSection: thisSection,
      selectedContent: newContentItem,
      selectedColumn: thisColumn,

      headersections: headercontentallIsDeselected && parent !== 'header' ? 
        get().headersections : 
        [...(parent === 'header' ? parentSections : get().headersections).map(s => s.id === thisSection.id ?
          {...s, columns: s.columns.map(c => c.id === thisColumn.id ?
            {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
              {...ct, selected: true}:
              {...ct, selected: false}
              )}:
            {...c, content: c.content.map(ct => ({...ct, selected: false}))}
          )} :
          {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
        )],
      bodysections: bodycontentallIsDeselected && parent !== 'body' ? 
      get().bodysections :
      [...(parent === 'body' ? parentSections : get().headersections).map(s => s.id === thisSection.id ?
        {...s, columns: s.columns.map(c => c.id === thisColumn.id ?
          {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
      footersections: footercontentallIsDeselected && parent !== 'footer' ? 
      get().footersections : 
      [...(parent === 'footer' ? parentSections : get().headersections).map(s => s.id === thisSection.id ?
        {...s, columns: s.columns.map(c => c.id === thisColumn.id ?
          {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
    }
  }),
  duplicateContentItem: (parent, sectionId, columnIndex, contentIndex) => set(() => {

    console.log('duplicateContentItem', parent, sectionId, columnIndex, contentIndex)
    
    let headercontentallIsDeselected = get().headersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let bodycontentallIsDeselected = get().bodysections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let footercontentallIsDeselected = get().footersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
   
    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    let columns = [...thisSection.columns]

    let thisColumn = columns[columnIndex]
    let newContents = [...thisColumn.content]

    let newContentItem = newContents[contentIndex]

    newContentItem = {
      ...newContentItem,
      id: uuid(), selected:true,
    }

    if(columns.length>1) newContents.splice(contentIndex+1, 0, newContentItem)
    
    thisColumn = {...thisColumn, content: newContents}

    // thisColumn = {...thisColumn, content: thisColumn.content.filter(ct => ct.id !== contentId)}

    columns.splice(columnIndex,1)
    columns.splice(columnIndex, 0, thisColumn)

    // columns = [...columns.map(c => ({...c, width: maxSectionWidth / columns.length}))]
    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let addNewSection =  {
      id:uuid(),
      parent: parent, 
      backgroundColor: thisSection.backgroundColor, 
      columns:[
        { 
          id:uuid(), 
          width: maxSectionWidth, 
          content: [newContentItem]
        }
      ], 
      selected:false, 
      isDragging:false
    }
    if(columns.length<=1) parentSections.splice(thisSectionIndex+1, 0, addNewSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if((!isUndefined(Tempid) || !isUndefined(Campid)) && columns.length>1) {
      let ContentOrder = newContents.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(addContentTemplate(Userid, Afid, newContentItem, ContentOrder, thisColumn.id, Tempid, Campid))
    }
    if((!isUndefined(Tempid) || !isUndefined(Campid)) && columns.length<=1) {
      let SectionsOrder = parentSections.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(addSectionToTemplate(Userid, Afid, addNewSection, Tempid, SectionsOrder, Campid))
    }

    return {
      selectedSection: columns.length<=1 ?addNewSection:thisSection,
      selectedContent: newContentItem,
      selectedColumn: columns.length<=1 ?addNewSection.columns[0] : thisColumn,

      headersections: headercontentallIsDeselected && parent !== 'header' ? 
        get().headersections : 
        [...(parent === 'header' ? parentSections : get().headersections).map(s => s.id === (columns.length<=1 ? addNewSection.id : thisSection.id) ?
          {...s, columns: s.columns.map(c => c.id === (columns.length<=1 ? addNewSection.columns[0].id : thisColumn.id) ?
            {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
              {...ct, selected: true}:
              {...ct, selected: false}
              )}:
            {...c, content: c.content.map(ct => ({...ct, selected: false}))}
          )} :
          {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
        )],
      bodysections: bodycontentallIsDeselected && parent !== 'body' ? 
      get().bodysections :
      [...(parent === 'body' ? parentSections : get().headersections).map(s => s.id === (columns.length<=1 ? addNewSection.id : thisSection.id) ?
        {...s, columns: s.columns.map(c => c.id === (columns.length<=1 ? addNewSection.columns[0].id : thisColumn.id) ?
          {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
      footersections: footercontentallIsDeselected && parent !== 'footer' ? 
      get().footersections : 
      [...(parent === 'footer' ? parentSections : get().headersections).map(s => s.id === (columns.length<=1 ? addNewSection.id : thisSection.id) ?
        {...s, columns: s.columns.map(c => c.id === (columns.length<=1 ? addNewSection.columns[0].id : thisColumn.id) ?
          {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, selected: false, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
    }
  }),
  addSocialItem: (parent, sectionId, columnId, contentId) => set(() => {

    console.log('addSocialItem')
    
    let headercontentallIsDeselected = get().headersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let bodycontentallIsDeselected = get().bodysections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let footercontentallIsDeselected = get().footersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
   
    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    let columns = [...thisSection.columns]

    let thisColumn = columns.find(c => c.id === columnId)
    let thisColumnIndex = indexOf(columns, thisColumn)
    let newContents = [...thisColumn.content]

    let thisContent = newContents.find(c => c.id === contentId)
    let thisContentIndex = indexOf(newContents, thisContent)

    let newSocial = {
      id: uuid(),
      value: 1,
      link: 'facebook.com/'
    }
    let newSocials = [...thisContent.socials, newSocial]

    thisContent = {
      ...thisContent,
      socials: newSocials
    }

    newContents.splice(thisContentIndex, 1)
    newContents.splice(thisContentIndex, 0, thisContent)
    
    thisColumn = {...thisColumn, content: newContents}

    columns.splice(thisColumnIndex,1)
    columns.splice(thisColumnIndex, 0, thisColumn)
    thisSection = {...thisSection, columns, selected: true}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      let SocialArray = newSocials.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(addSocialMailTemplate(Userid, Afid, Tempid, newSocial, SocialArray, contentId, Campid))
    }

    return {
      selectedSection: thisSection,
      selectedContent: thisContent,
      selectedColumn: thisColumn,

      headersections: headercontentallIsDeselected && parent !== 'header' ? 
        get().headersections : 
        [...(parent === 'header' ? parentSections : get().headersections).map(s => s.id === thisSection.id ?
          {...s, columns: s.columns.map(c => c.id === thisColumn.id ?
            {...c, content: c.content.map(ct => ct.id === thisContent.id ?
              {...ct, selected: true}:
              {...ct, selected: false}
              )}:
            {...c, content: c.content.map(ct => ({...ct, selected: false}))}
          )} :
          {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
        )],
      bodysections: bodycontentallIsDeselected && parent !== 'body' ? 
      get().bodysections :
      [...(parent === 'body' ? parentSections : get().headersections).map(s => s.id === thisSection.id ?
        {...s, columns: s.columns.map(c => c.id === thisColumn.id ?
          {...c, content: c.content.map(ct => ct.id === thisContent.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
      footersections: footercontentallIsDeselected && parent !== 'footer' ? 
      get().footersections : 
      [...(parent === 'footer' ? parentSections : get().headersections).map(s => s.id === thisSection.id ?
        {...s, columns: s.columns.map(c => c.id === thisColumn.id ?
          {...c, content: c.content.map(ct => ct.id === thisContent.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
    }
  }),
  updateSocialItem: (parent, sectionId, columnId, contentId, social) => set(() => {

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
    let columns = [...thisSection.columns]
    let thisColumn = columns.find(c => c.id === columnId)
    let thisColumnIndex = indexOf(columns, thisColumn)

    let thisContents = [...thisColumn.content]
    let thisContent = thisContents.find(c => c.id === contentId)
    let thisContentIndex = indexOf(thisContents, thisContent)

    let thisSocials = [...thisContent.socials]
    let thisSocial = thisSocials.find(s => s.id === social.id)
    let thisSocialIndex = indexOf(thisSocials, thisSocial)

    thisSocial = {...thisSocial, ...social}
    thisSocials.splice(thisSocialIndex, 1)
    thisSocials.splice(thisSocialIndex, 0, thisSocial)

    thisContent = {...thisContent, socials: thisSocials}
    thisContents.splice(thisContentIndex, 1)
    thisContents.splice(thisContentIndex, 0, thisContent)

    thisColumn = {...thisColumn, content: thisContents}

    columns.splice(thisColumnIndex,1)
    columns.splice(thisColumnIndex, 0, thisColumn)


    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      const {Userid, Afid} = getDispatchData()
      store.dispatch(updateSocialMailTemplate(Userid, Afid, thisSocial, Tempid, Campid))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? thisSection : get().selectedSection),
      selectedContent: isNull(get().selectedContent) ? get().selectedContent : (get().selectedContent.id === thisContent.id ? thisContent : get().selectedContent)
    }
  }),
  removeSocialItem: (parent, sectionId, columnId, contentId, socialId) => set(() => {

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
   
    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    let columns = [...thisSection.columns]

    let thisColumn = columns.find(c => c.id === columnId) 
    let thisColumnIndex = indexOf(columns, thisColumn)

    let thisContents = [...thisColumn.content]
    let thisContent = thisContents.find(c => c.id === contentId)
    let thisContentIndex = indexOf(thisContents, thisContent)

    let newSocials = [...thisContent.socials.filter(c => c.id !== socialId)]

    thisContent = {
      ...thisContent,
      socials: newSocials
    }

    thisContents.splice(thisContentIndex,1)
    thisContents.splice(thisContentIndex, 0, thisContent)

    thisColumn = {...thisColumn, content: thisContents}

    columns.splice(thisColumnIndex,1)
    columns.splice(thisColumnIndex, 0, thisColumn)

    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      const SocialArray = newSocials.map(c => c.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(removeSocialMailTemplate(Userid, Afid, {id:socialId}, SocialArray, Tempid, Campid))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? thisSection : get().selectedSection),
      selectedContent: isNull(get().selectedContent) ? get().selectedContent : (get().selectedContent.id === contentId ? thisContent : get().selectedContent)
    }
  }),
  moveSocial: (parent, sectionId, columnId, contentId, fromIndex, toIndex) => set(() => {

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
   
    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    let columns = [...thisSection.columns]

    let thisColumn = columns.find(c => c.id === columnId) 
    let thisColumnIndex = indexOf(columns, thisColumn)

    let thisContents = [...thisColumn.content]
    let thisContent = thisContents.find(c => c.id === contentId)
    let thisContentIndex = indexOf(thisContents, thisContent)


    let thisSocials = [...thisContent.socials]
    let thisSocial = thisSocials[fromIndex]

    thisSocials.splice(fromIndex, 1)
    thisSocials.splice(toIndex, 0, thisSocial)

    thisContent = {...thisContent, socials: thisSocials}

    thisContents.splice(thisContentIndex,1)
    thisContents.splice(thisContentIndex, 0, thisContent)

    thisColumn = {...thisColumn, content: thisContents}

    columns.splice(thisColumnIndex,1)
    columns.splice(thisColumnIndex, 0, thisColumn)

    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      const SocialArray = thisSocials.map(c => c.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(moveSocialMailTemplate(Userid, Afid, SocialArray, Tempid, Campid))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? thisSection : get().selectedSection),
      selectedContent: isNull(get().selectedContent) ? get().selectedContent : (get().selectedContent.id === contentId ? thisContent : get().selectedContent)
    }
  }),
  updateColumnWidths: (parent, sectionId, widthsArr) => set(() => {

    console.log('updateColumnWidths')

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
    let columns = [...thisSection.columns.map((c,i) => ({...c, width: widthsArr[i].width}))]

    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      const {Userid, Afid} = getDispatchData()
      store.dispatch(updateColumnWidthsTemplate(Userid, Afid, widthsArr, Tempid, Campid))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? thisSection : get().selectedSection)
    }
  }),
  updateColumnByIdObj: (parent, sectionId, columnId, obj) => set(() => {

    console.log('updateColumnByIdObj')

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
    let columns = [...thisSection.columns]
    let thisColumn = columns.find(c => c.id === columnId)

    let thisColumnIndex = indexOf(columns, thisColumn)

    thisColumn = {...thisColumn, ...obj}

    columns.splice(thisColumnIndex,1)
    columns.splice(thisColumnIndex, 0, thisColumn)


    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? thisSection : get().selectedSection)
    }
  }),
  addSection: (parent, index, columnContentType, addsection ) => set(() => { 

    
    let headercontentallIsDeselected = get().headersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let bodycontentallIsDeselected = get().bodysections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))
    let footercontentallIsDeselected = get().footersections.every((s) => s.columns.every(c => c.content.every(ct => !ct.selected)))

    let newSection = isUndefined(addsection) ? 
    {
      id:uuid(),
      parent: parent, 
      backgroundColor: '#ffffff00', 
      columns:[
        { 
          id:uuid(), 
          width: maxSectionWidth, 
          content: [{
            id: uuid(),
            contentType: columnContentType, 
            ...defaultContentParams(columnContentType),
            selected: true
          }]
         
        }
      ], 
      selected:false, 
      isDragging:false
    } : 
    {
      ...addsection, 
      id: uuid(), 
      columns: addsection.columns.map(c => ({...c, id: uuid(), content: c.content.map((ct) => ({...ct, id:uuid(), selected: false}))})), 
      selected: false
    }

    let parentSections = [...get()[`${parent}sections`]]
    parentSections.splice(isUndefined(addsection) ? index : (index+1), 0,  newSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      let SectionsOrder = parentSections.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(addSectionToTemplate(Userid, Afid, newSection, Tempid, SectionsOrder, Campid))
    }

    if(!isUndefined(addsection)) {
      return {
        [`${parent}sections`]:parentSections
      }
    }

    let thisColumn = newSection.columns[0]
    let newContentItem = thisColumn.content[0]


    return {
      selectedSection: newSection,
      selectedContent: newContentItem,
      selectedColumn: thisColumn,

      headersections: headercontentallIsDeselected && parent !== 'header' ? 
        get().headersections : 
        [...(parent === 'header' ? parentSections : get().headersections).map(s => s.id === newSection.id ?
          {...s, columns: s.columns.map(c => c.id === thisColumn.id ?
            {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
              {...ct, selected: true}:
              {...ct, selected: false}
              )}:
            {...c, content: c.content.map(ct => ({...ct, selected: false}))}
          )} :
          {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
        )],
      bodysections: bodycontentallIsDeselected && parent !== 'body' ? 
      get().bodysections :
      [...(parent === 'body' ? parentSections : get().headersections).map(s => s.id === newSection.id ?
        {...s, columns: s.columns.map(c => c.id === thisColumn.id ?
          {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
      footersections: footercontentallIsDeselected && parent !== 'footer' ? 
      get().footersections : 
      [...(parent === 'footer' ? parentSections : get().headersections).map(s => s.id === newSection.id ?
        {...s, columns: s.columns.map(c => c.id === thisColumn.id ?
          {...c, content: c.content.map(ct => ct.id === newContentItem.id ?
            {...ct, selected: true}:
            {...ct, selected: false}
            )}:
          {...c, content: c.content.map(ct => ({...ct, selected: false}))}
        )} :
        {...s, columns: s.columns.map(c => ({...c, content: c.content.map(ct => ({...ct, selected: false}))}))} 
      )],
    }
  }), 
  moveContentNewSection: ( fromParent, toParent, toIndex, contentId, fromColumnId, fromSectionId ) => set(() => { 
    
    let fromParentSections = [...get()[`${fromParent}sections`]]
    let toParentSections = [...get()[`${toParent}sections`]]

    let fromThisSection = fromParentSections.find(s => s.id === fromSectionId)

    let shouldRemoveOriginSection = fromThisSection.columns.length === 1 && isEmpty(fromThisSection.columns.filter(c => c.content > 1))

    let fromSectionIndex = indexOf(fromParentSections, fromThisSection)
    let fromThisNewSection = {...fromParentSections[fromSectionIndex]}

    let fromColumns = [...fromThisNewSection.columns]

    let fromThisColumn = fromColumns.find(c => c.id === fromColumnId)
    let fromColumnsIndex = indexOf(fromColumns, fromThisColumn)
    let fromThisNewColumn = {...fromColumns[fromColumnsIndex]}

    let fromContentItems = [...fromThisNewColumn.content]

    let fromThisContent = fromContentItems.find(c => c.id === contentId)
    let fromContentIndex = indexOf(fromContentItems, fromThisContent)
    let thisContent = {...fromContentItems[fromContentIndex]}

    let newSection = {
      id:uuid(),
      parent: toParent, 
      backgroundColor: fromThisSection.backgroundColor, 
      columns:[
        { 
          id:uuid(), 
          width: maxSectionWidth, 
          content: [thisContent]
         
        }
      ], 
      selected:false, 
      isDragging:false
    } 

    if(fromParent === toParent) {
     
      fromContentItems.splice(fromContentIndex, 1)

      fromThisNewColumn = {...fromThisNewColumn, content: fromContentItems}
      fromColumns.splice(fromColumnsIndex, 1)
      fromColumns.splice(fromColumnsIndex, 0, fromThisNewColumn)

      fromThisSection = {...fromThisSection, columns: fromColumns}
      toParentSections.splice(fromSectionIndex, 1)
      if(!shouldRemoveOriginSection) toParentSections.splice(fromSectionIndex, 0, fromThisSection)

      toParentSections.splice((shouldRemoveOriginSection && toIndex > fromSectionIndex) ? (toIndex - 1) : toIndex, 0, newSection)

      
      let Tempid = history?.location?.state?.Tempid
      let Campid = history?.location?.state?.Campid
      if(!isUndefined(Tempid) || !isUndefined(Campid)) {
        let SectionsOrder = toParentSections.map(s => s.id)
        const {Userid, Afid} = getDispatchData()
        store.dispatch(moveContentNewSectionTemplate(Userid, Afid, newSection, thisContent, SectionsOrder, Tempid, Campid, shouldRemoveOriginSection ? fromThisSection.id : null))
      }
      
      return {
        [`${toParent}sections`]:toParentSections,
        selectedSection: newSection
      }
    }

    fromContentItems.splice(fromContentIndex, 1)

    fromThisNewColumn = {...fromThisNewColumn, content: fromContentItems}
    fromColumns.splice(fromColumnsIndex, 1)
    fromColumns.splice(fromColumnsIndex, 0, fromThisNewColumn)

    fromThisSection = {...fromThisSection, columns: fromColumns}
    fromParentSections.splice(fromSectionIndex, 1)
    if(!shouldRemoveOriginSection) fromParentSections.splice(fromSectionIndex, 0, fromThisSection)

    toParentSections.splice(toIndex, 0, newSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      let SectionsOrder = toParentSections.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(moveContentNewSectionTemplate(Userid, Afid, newSection, thisContent, SectionsOrder, Tempid, Campid, shouldRemoveOriginSection ? fromThisSection.id : null))
    }

    return {
      [`${fromParent}sections`]: fromParentSections,
      [`${toParent}sections`]: toParentSections,
      selectedSection: newSection
    }
  }), 
 
  moveSection: (fromParent, toParent, fromIndex, toIndex) => set(() => { 

    let fromParentSections = [...get()[`${fromParent}sections`]]
    let toParentSections = [...get()[`${toParent}sections`]]

    let section = {...fromParentSections[fromIndex], parent: toParent}

    // console.log(fromParent === toParent, fromParent)
    // console.log(fromParent === toParent, toParent)

    

    if(fromParent === toParent) {
      toParentSections.splice(fromIndex, 1)
      toParentSections.splice(toIndex, 0, section)

      let Tempid = history?.location?.state?.Tempid
      let Campid = history?.location?.state?.Campid
      if(!isUndefined(Tempid) || !isUndefined(Campid)) {
        let SectionsOrder = toParentSections.map(s => s.id)
        const {Userid, Afid} = getDispatchData()
        store.dispatch(moveSectionTemplate(Userid, Afid, section, SectionsOrder, Tempid, Campid))
      }

      return {
        [`${toParent}sections`]:toParentSections
      }
    }

    fromParentSections.splice(fromIndex, 1)
    toParentSections.splice(toIndex, 0, section)

    // console.log({
    //   [`${fromParent}sections`]: fromParentSections,
    //   [`${toParent}sections`]: toParentSections,
    //   selectedSection: section.selected?section:get().selectedSection
    // }, section.selected)
    
    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      let SectionsOrder = toParentSections.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(moveSectionTemplate(Userid, Afid, section, SectionsOrder, Tempid, Campid))
    }

    return {
      [`${fromParent}sections`]: fromParentSections,
      [`${toParent}sections`]: toParentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === section.id ? section : get().selectedSection),
    }
  }), 

  updateContent: (parent, sectionId, columnId, content, isDispatch = true) => set(() => {

    console.log('updateContent')

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
    let columns = [...thisSection.columns]
    let thisColumn = columns.find(c => c.id === columnId)
    let thisColumnIndex = indexOf(columns, thisColumn)

    let thisContents = [...thisColumn.content]
    let thisContent = thisContents.find(c => c.id === content.id)
    let thisContentIndex = indexOf(thisContents, thisContent)

    thisContent = {...content}
    thisContents.splice(thisContentIndex, 1)
    thisContents.splice(thisContentIndex, 0, thisContent)

    thisColumn = {...thisColumn, content: thisContents}

    columns.splice(thisColumnIndex,1)
    columns.splice(thisColumnIndex, 0, thisColumn)


    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if((!isUndefined(Tempid) || !isUndefined(Campid)) && isDispatch) {
      let ContentOrder = thisContents.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(updateContentTemplate(Userid, Afid, thisContent, ContentOrder, Tempid, Campid))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? thisSection : get().selectedSection),
      selectedContent: isNull(get().selectedContent) ? get().selectedContent : (get().selectedContent.id === thisContent.id ? thisContent : get().selectedContent)
    }
  }),
  updateContentByIdObj: (parent, sectionId, columnId, contentId, obj) => set(() => {

    console.log('updateContent')

    let parentSections = [...get()[`${parent}sections`]]
    let thisSection = parentSections.find(s => s.id === sectionId)
    let columns = [...thisSection.columns]
    let thisColumn = columns.find(c => c.id === columnId)
    let thisColumnIndex = indexOf(columns, thisColumn)

    let thisContents = [...thisColumn.content]
    let thisContent = thisContents.find(c => c.id === contentId)
    let thisContentIndex = indexOf(thisContents, thisContent)

    thisContent = {...thisContent, ...obj}
    thisContents.splice(thisContentIndex, 1)
    thisContents.splice(thisContentIndex, 0, thisContent)

    thisColumn = {...thisColumn, content: thisContents}

    columns.splice(thisColumnIndex,1)
    columns.splice(thisColumnIndex, 0, thisColumn)


    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)

    thisSection = {...thisSection, columns}

    parentSections.splice(thisSectionIndex, 0, thisSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      let ContentOrder = thisContents.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(updateContentTemplate(Userid, Afid, thisContent, ContentOrder, Tempid, Campid))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? thisSection : get().selectedSection),
      selectedContent: isNull(get().selectedContent) ? get().selectedContent : (get().selectedContent.id === thisContent.id ? thisContent : get().selectedContent)
    }
  }),

  moveContentItem: (fromParent, toParent, fromColumnId, toColumnId, fromSectionId, toSectionId, fromIndex, toIndex) => set(() => { 

    console.log(fromParent, toParent, fromColumnId, toColumnId, fromSectionId, toSectionId, fromIndex, toIndex)

    let fromParentSections = [...get()[`${fromParent}sections`]]
    let toParentSections = [...get()[`${toParent}sections`]]

    let fromThisSection = fromParentSections.find(s => s.id === fromSectionId)

    let shouldRemoveOriginSection = fromThisSection.columns.length === 1 && isEmpty(fromThisSection.columns.filter(c => c.content > 1))

    let fromSectionIndex = indexOf(fromParentSections, fromThisSection)
    let fromThisNewSection = {...fromParentSections[fromSectionIndex]}

    let fromColumns = [...fromThisNewSection.columns]

    let fromThisColumn = fromColumns.find(c => c.id === fromColumnId)
    let fromColumnsIndex = indexOf(fromColumns, fromThisColumn)
    let fromThisNewColumn = {...fromColumns[fromColumnsIndex]}

    let fromContentItems = [...fromThisNewColumn.content]
    let thisContent = {...fromContentItems[fromIndex]}

    
    let toThisSection = toParentSections.find(s => s.id === toSectionId)
    let toSectionIndex = indexOf(toParentSections, toThisSection)
    let toThisNewSection = {...toParentSections[toSectionIndex]}

    let toColumns = [...toThisNewSection.columns]

    let toThisColumn = toColumns.find(c => c.id === toColumnId)
    let toColumnsIndex = indexOf(toColumns, toThisColumn)
    let toThisNewColumn = {...toColumns[toColumnsIndex]}

    let toContentItems = [...toThisNewColumn.content]


    if(fromColumnId === toColumnId) {
      toContentItems.splice(fromIndex, 1)
      toContentItems.splice(toIndex, 0, thisContent)

      toThisNewColumn = {...toThisNewColumn, content: toContentItems}
      toColumns.splice(toColumnsIndex, 1)
      toColumns.splice(toColumnsIndex, 0, toThisNewColumn)

      toThisNewSection = {...toThisNewSection, columns: toColumns}
      toParentSections.splice(toSectionIndex, 1)
      toParentSections.splice(toSectionIndex, 0, toThisNewSection)

      let Tempid = history?.location?.state?.Tempid
      let Campid = history?.location?.state?.Campid
      if(!isUndefined(Tempid) || !isUndefined(Campid)) {
        let ContentOrder = toContentItems.map(s => s.id)
        const {Userid, Afid} = getDispatchData()
        store.dispatch(moveContentTemplate(Userid, Afid, thisContent, ContentOrder, toColumnId, Tempid, Campid, null))
      }

      return {
        [`${toParent}sections`]:toParentSections
      }
    }
    if(fromSectionId === toSectionId) {
      fromContentItems.splice(fromIndex, 1)
      toContentItems.splice(toIndex, 0, thisContent)

      fromThisNewColumn = {...fromThisNewColumn, content: fromContentItems}
      toColumns.splice(fromColumnsIndex, 1)
      toColumns.splice(fromColumnsIndex, 0, fromThisNewColumn)

      toThisNewColumn = {...toThisNewColumn, content: toContentItems}
      toColumns.splice(toColumnsIndex, 1)
      toColumns.splice(toColumnsIndex, 0, toThisNewColumn)

      toThisNewSection = {...toThisNewSection, columns: toColumns}
      toParentSections.splice(toSectionIndex, 1)
      toParentSections.splice(toSectionIndex, 0, toThisNewSection)

      let Tempid = history?.location?.state?.Tempid
      let Campid = history?.location?.state?.Campid
      if(!isUndefined(Tempid) || !isUndefined(Campid)) {
        let ContentOrder = toContentItems.map(s => s.id)
        const {Userid, Afid} = getDispatchData()
        store.dispatch(moveContentTemplate(Userid, Afid, thisContent, ContentOrder, toColumnId, Tempid, Campid, null))
      }

      return {
        [`${toParent}sections`]:toParentSections,
      }
    }
    if(fromParent === toParent) {
      fromContentItems.splice(fromIndex, 1)
      toContentItems.splice(toIndex, 0, thisContent)

      fromThisNewColumn = {...fromThisNewColumn, content: fromContentItems}
      fromColumns.splice(fromColumnsIndex, 1)
      fromColumns.splice(fromColumnsIndex, 0, fromThisNewColumn)

      fromThisSection = {...fromThisSection, columns: fromColumns}
      toParentSections.splice(fromSectionIndex, 1)
      // toParentSections.splice(fromSectionIndex, 0, fromThisSection)
      if(!shouldRemoveOriginSection) toParentSections.splice(fromSectionIndex, 0, fromThisSection)

      toThisNewColumn = {...toThisNewColumn, content: toContentItems}
      toColumns.splice(toColumnsIndex, 1)
      toColumns.splice(toColumnsIndex, 0, toThisNewColumn)

      toThisNewSection = {...toThisNewSection, columns: toColumns}
      toParentSections.splice((shouldRemoveOriginSection && toSectionIndex > fromSectionIndex) ? (toSectionIndex - 1) : toSectionIndex, 1)
      // toParentSections.splice(toSectionIndex, 0, toThisNewSection)
      toParentSections.splice((shouldRemoveOriginSection && toSectionIndex > fromSectionIndex) ? (toSectionIndex - 1) : toSectionIndex, 0, toThisNewSection)

      let Tempid = history?.location?.state?.Tempid
      let Campid = history?.location?.state?.Campid
      if(!isUndefined(Tempid) || !isUndefined(Campid)) {
        let ContentOrder = toContentItems.map(s => s.id)
        const {Userid, Afid} = getDispatchData()
        store.dispatch(moveContentTemplate(Userid, Afid, thisContent, ContentOrder, toColumnId, Tempid, Campid, shouldRemoveOriginSection ? fromThisSection.id : null))
      }

      return {
        [`${toParent}sections`]:toParentSections,
      }
    }


    toContentItems.splice(toIndex, 0, thisContent)
    fromContentItems.splice(fromIndex, 1)

    fromThisNewColumn = {...fromThisNewColumn, content: fromContentItems}
    fromColumns.splice(fromColumnsIndex, 1)
    fromColumns.splice(fromColumnsIndex, 0, fromThisNewColumn)

    fromThisSection = {...fromThisSection, columns: fromColumns}
    fromParentSections.splice(fromSectionIndex, 1)
    // fromParentSections.splice(fromSectionIndex, 0, fromThisSection)
    if(!shouldRemoveOriginSection) fromParentSections.splice(fromSectionIndex, 0, fromThisSection)

    toThisNewColumn = {...toThisNewColumn, content: toContentItems}
    toColumns.splice(toColumnsIndex, 1)
    toColumns.splice(toColumnsIndex, 0, toThisNewColumn)

    toThisNewSection = {...toThisNewSection, columns: toColumns}
    toParentSections.splice(toSectionIndex, 1)
    // toParentSections.splice(toSectionIndex, 0, toThisNewSection)
    toParentSections.splice((shouldRemoveOriginSection) ? (toSectionIndex - 1) : toSectionIndex, 0, toThisNewSection)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      let ContentOrder = toContentItems.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(moveContentTemplate(Userid, Afid, thisContent, ContentOrder, toColumnId, Tempid, Campid, shouldRemoveOriginSection ? fromThisSection.id : null))
    }

    return {
      [`${fromParent}sections`]: fromParentSections,
      [`${toParent}sections`]: toParentSections,
    }
  }), 
  updateSection: (parent, section) => set(() => {

    let parentSections = [...get()[`${parent}sections`]]

    let thisSection = parentSections.find(s => s.id === section.id)
    let thisSectionIndex = indexOf(parentSections, thisSection)
    parentSections.splice(thisSectionIndex,1)
    parentSections.splice(thisSectionIndex, 0, section)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      let SectionsOrder = parentSections.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(updateSectionMailTemplate(Userid, Afid, section, SectionsOrder, Tempid, Campid))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? section : get().selectedSection),
    }
  }),
  removeSection: (parent, index) => set(() => { 


    let parentSections = [...get()[`${parent}sections`]]

    let thisSection = isUndefined(parentSections[index]) ? {} : parentSections[index]

    parentSections.splice(index, 1)

    let Tempid = history?.location?.state?.Tempid
    let Campid = history?.location?.state?.Campid
    if(!isUndefined(Tempid) || !isUndefined(Campid)) {
      let SectionsOrder = parentSections.map(s => s.id)
      const {Userid, Afid} = getDispatchData()
      store.dispatch(removeSectionTemplate(Userid, Afid, thisSection, SectionsOrder, Tempid, Campid))
    }

    return {
      [`${parent}sections`]: parentSections,
      selectedSection: isNull(get().selectedSection) ? get().selectedSection : (get().selectedSection.id === thisSection.id ? null : get().selectedSection)
    }
  }), 
})))

export default useStore